exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lesson[data-v-573ab662]{background:#fff}.lesson iframe[data-v-573ab662]{width:100%;height:100vh}.lesson h1[data-v-573ab662]{padding:10px 20px;font-weight:500}", ""]);

// exports
